class Member {
	static fromArray(data, list) {
		let inst = new Member(list);
		inst._id = data.shift();
		inst._name = data.shift();
		inst.type = data.shift();
		inst._allocation = data.shift();

		inst.buildElem();
		return inst;
	}

	constructor(list) {
		this._list = list;

		this._id = 0;
		this._name = null;
		this._type = null;
		this._allocation = null;
		this._typeName = '';
	}
	
	buildElem() {
		this._elem = div(null, [
			this._chkBox = chk('alt-chk'),
			div('list-row align-items-center hilight', [
				div('col-auto i-rg chk-box'),
				div('col-4', this._name),
				div('col-auto', this.typeButton = btn('btn', this._typeName, {'click':this.selectType.bind(this)})),
				div('col-auto ms-auto', [
					this.teamButton = btn('btn tooltip i-rg i-teams', '',{
						'click':this.showTeamChecklist.bind(this)
					},{
						'data-tip':_("Teams this member belongs to")
					}),
					this.allocationButton = btn('btn i-rg i-subscription tooltip', null, {
						'click':this.setAllocation.bind(this)
					}, {
						'data-tip':_("Click to allocate / de-allocate licence")
					})
				])
			])
		]);
		
		this.allocationButton.style.color = this.allocation ? 'green' : '#dddddd';
		onEv(this._elem, 'click', () => selection.toggle(this));
	}

	update() {
		this.typeButton.innerHTML = this._typeName;
	}

	get id() {return this._id;}

	get type() {return this._type;}
	set type(v) {
		this._type = v;
		switch(v) {
			case AC.MEMBER_MANAGER: this._typeName = _("Manager"); break;
			case AC.MEMBER_CONTRIBUTOR: this._typeName = _("Contributor"); break;
			case AC.MEMBER_ASSOCIATE: this._typeName = _("Associate"); break;
			default: this._typeName = _("Pending");
		}
	}

	get allocation() {
		return this._allocation != null && 0 < this._allocation;
	}
	set allocation(value) {
		this._allocation = value;
		this.allocationButton.style.color = value ? 'green' : '#dddddd';
	}

	get elem() {return this._elem;}

	get checked() {return this._chkBox.checked;}
	set checked(v) {this._chkBox.checked = !!v;}
	
	showTeamChecklist(ev) {
		if (typeof teams === 'undefined' || !teams instanceof TeamList) return;
		teams.mapOne(this._id, this.teamButton);
		stopEv(ev);
	}

	selectType(ev) {
		this._list.selectType(this);
		stopEv(ev);
	}

	setType(type) {
		ajg('member/type', [
			'id=' + encodeURI(this._id),
			'type=' + encodeURI(type)
		], null, (reply) => {
			if (showError(reply)) return;
			this.type = type;
			this.update();
		});
	}

	setAllocation(event) {
		if (this.allocation) {
			Dialog.Confirm(
				_("Confirm REMOVE licence allocation!"),
				_("REMOVE LICENCE"),
				() => {
					ajg('allocation/remove', [
						'id=' + this.id
					], null, (reply) => {
						if (showError(reply)) return;
						this.allocation = 0;
					})
				}
			);
		} else {
			Dialog.Confirm(
				_("Confirm ALLOCATE licence to member"),
				_("ALLOCATE LICENCE"),
				() => {
					ajg('allocation/give', [
						'id=' + this.id
					], null, (reply) => {
						if (showError(reply)) return;
						this.allocation = 1;
					})
				}
			);
		}
		stopEv(event);
	}
}